import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { Link } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import useSnack from 'hooks/useSnack';
import { API } from 'aws-amplify';
import { Query } from 'react-apollo';
import Spin from 'components/common/Spin';
import Agreement from './Agreement';
import ProductSelection from './ProductSelection';
import Payment from './Payment';
import AddressFrom from './Address';
import { GET_ADDRESS } from 'graphql/parent';
import ProductUpgrade from './ProductUpgrade';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const Upgrade = ({ student, onClose }) => {
  const snack = useSnack();
  const [product, setProduct] = useState();
  const [tos, setTos] = useState(false);
  const [values, setValues] = useState({});
  const [customer, setCustomer] = useState();

  useEffect(() => {
    API.get('api', `/stripe/customer`).then(
      (resp) => {
        console.log(resp);
        setCustomer(resp);
      },
      (e) => {
        console.log(e);
        snack.error('Error loading card details');
      },
    );
  }, []);

  const setStep = () => {
    setProduct();
    setTos();
  };

  const onFieldChange = (field, value) => {
    setValues({
      ...values,
      [field]: value,
    });
  };

  const onSubmitPayment = (token) => {
    if (!token && !customer) {
      return snack.error('Missing payment token or customer');
    }
    return API.post('api', '/users/upgrade_trial', {
      body: {
        studentId: student.user_id,
        planId: product.plan_id,
        coupon: values.coupon,
        token,
      },
    }).then(
      (resp) => {
        window.alert('Upgrade successful!');
        window.location.reload();
      },
      (err) => {
        if (err.response?.data) {
          snack.error(err.response.data.message);
        } else {
          snack.error(err.message);
        }
      },
    );
  };

  return (
    <Dialog open maxWidth="md" fullWidth disableBackdropClick>
      <DialogTitle onClose={onClose}>Purchase Subscription</DialogTitle>
      <Query query={GET_ADDRESS}>
        {({ data, loading, refetch }) => {
          if (loading) return <Spin spinning />;

          const hasAddress = data.user_address.length;

          return (
            <DialogContent dividers>
              {!product ? (
                <ProductUpgrade onSelect={setProduct} />
              ) : !tos ? (
                <Agreement
                  product={product}
                  tos={values.tos}
                  onNext={() => setTos(true)}
                  onBack={setStep}
                  onChange={onFieldChange}
                  upgrade
                />
              ) : !hasAddress ? (
                <AddressFrom onBack={setStep} onNext={refetch} />
              ) : (
                <Payment
                  customer={customer}
                  onChange={setValues}
                  onSubmit={onSubmitPayment}
                  data={values}
                  product={product}
                  setStep={setStep}
                />
              )}
            </DialogContent>
          );
        }}
      </Query>
    </Dialog>
  );
};

export default Upgrade;
